(function () {
  // The tag now sits in two places - snippets/hoopers-upsells-boot (every page)
  // and snippets/hoopers-upsells (the buy box itself). Same src, but a browser
  // executes both tags, so bail on the second run rather than installing a
  // second observer.
  if (window.__hupBoot) return;
  window.__hupBoot = 1;

  // Every [data-hup] block gets wired, including ones that appear LATER. That
  // is not defensive coding, it is the whole bug: quick shop fetches
  // /products/HANDLE?view=quick and injects the buy box into a collection page,
  // long after this script has run. The first version did the work once, at
  // load, against document.querySelector - on a collection page there was no
  // block yet, so it returned immediately and every control kept its native
  // properties[...] name. Anything added from the grid therefore shipped blank
  // `שם`, `מספר`, `פאץ׳ שרוול` and `גרסה` onto the order.
  //
  // The tell in the data: leaking orders all landed on a collection page, and a
  // single order could hold one clean line (added from a product page) beside a
  // leaking one (added from the grid).

  function initBlock(root) {
    if (!root || root.__hup) return;
    root.__hup = 1;

    var sum = root.querySelector('[data-hup-sum]');
    var sumText = root.querySelector('[data-hup-sum-text]');
    var fit = root.querySelector('[data-hup-fit]');
    var why = root.querySelector('[data-hup-why]');
    var cmp = root.querySelector('[data-hup-cmp]');
    var print = root.querySelector('[data-hup-print]');
    var fields = root.querySelector('[data-hup-fields]');
    var nameEl = root.querySelector('[data-hup-name]');
    var numEl = root.querySelector('[data-hup-num]');
    var form = root.closest('form');

    // Controls are found by their data-* attributes, never by name - the names
    // are about to change.
    var verEls = root.querySelectorAll('[data-hup-pro]');
    var patchEls = root.querySelectorAll('.hup__in[type="radio"]:not([data-hup-pro])');

    // 1. Take the visible controls OFF the form.
    //
    // `hidden` does not stop a field submitting; only `disabled` does - and
    // disabling the checked no-patch radio would make the chip unclickable.
    // So they are renamed to something Shopify ignores. Radios keep working as
    // a group because every member shared one original name and so maps to one
    // new name. The random suffix keeps two blocks on one page from colliding.
    var uid = 'hup-ui-' + Math.random().toString(36).slice(2, 8) + '-';
    var seen = {}, next = 0;
    var native = root.querySelectorAll('[name^="properties["]');
    for (var n = 0; n < native.length; n++) {
      var el0 = native[n], key = el0.getAttribute('name');
      if (!seen[key]) seen[key] = uid + (++next);
      el0.setAttribute('name', seen[key]);
    }

    // 2. The hidden inputs this block owns.
    //
    // 🔴 HISTORY, 04/09/26. The pricing pipe used to be Easify's PUBLIC app: it
    // ran a cart transform and charged whatever `_po:items:addon` said. Easify
    // was uninstalled, and that payload then did the exact opposite of paying -
    // a line carrying `_po:items:addon` was charged NOTHING, while the same
    // line without it was charged correctly. Verified in a live cart on a 149 ₪
    // shirt: patch alone 159, player version alone 168, print alone 159, and
    // all of them together with the addon payload 149. So the payload is no
    // longer written. The visible properties are what the pricing rail reads.
    var out = null;
    if (form) {
      var mk = function (propName) {
        var el = document.createElement('input');
        el.type = 'hidden';
        el.name = 'properties[' + propName + ']';
        el.disabled = true;
        form.appendChild(el);
        return el;
      };
      out = {
        print: mk('התאמה אישית של המוצר'),
        name: mk('שם'),
        num: mk('מספר'),
        patch: mk('פאץ׳ שרוול'),
        ver: mk('גרסה')
      };
    }

    // No value means disabled, and a disabled field is not submitted.
    function put(el, value) {
      if (!el) return;
      if (value) { el.disabled = false; el.value = value; }
      else { el.disabled = true; el.value = ''; }
    }

    function pick(list) {
      for (var i = 0; i < list.length; i++) if (list[i].checked) return list[i];
      return null;
    }

    function syncPipe() {
      if (!out) return;

      // 28/10/26: an OPEN print is not a bought print. Billed only after the
      // shopper pressed the explicit "הוסיפו" button (see printState below).
      var printOn = !!(print && print.checked && !printPending());
      var printVal = printOn ? (print.getAttribute('data-hup-value') || print.value) : '';
      // Sanitised HERE too, not only on input: an Android IME commits its
      // composed word after the last input event, so Hebrew typed there used to
      // reach the order untouched (24/09/26: "שקד", "אייל בן טוב").
      if (nameEl) cleanName();
      var nameVal = printOn && nameEl ? nameEl.value.trim() : '';
      var numVal = printOn && numEl ? numEl.value : '';

      var patchEl = pick(patchEls);
      var patchVal = patchEl ? patchEl.value : '';

      var verEl = pick(verEls);
      var verVal = verEl ? verEl.value : '';

      // What the shopper reads in the cart and at checkout - and what the
      // pricing rail bills from. Nothing else is submitted.
      put(out.print, printOn ? printVal : '');
      put(out.name, nameVal);
      put(out.num, numVal);
      put(out.patch, patchVal);
      put(out.ver, verVal);
    }

    if (why && cmp) {
      why.addEventListener('click', function () {
        var open = cmp.hidden;
        cmp.hidden = !open;
        why.setAttribute('aria-expanded', String(open));
        // A playing explainer keeps its sound when the panel is hidden - stop it.
        var vid = cmp.querySelector('video');
        if (vid && !open) vid.pause();
      });
    }

    /* ── 28/10/26 (owner): the print is added only by an explicit button ──
       Ticking "שם ומספר" (or a quick-fill player chip, which ticks it) now only
       OPENS the fields. Nothing is billed and no price moves until the shopper
       presses "הוסיפו · ₪10". While open-but-not-added the checkbox carries
       data-hup-pending and data-hup-price="0", so every total on the page (this
       block's sum, the buy drawer, the set extras) reads 0 for it without being
       touched; the billing pipe above reads printPending() directly. Un-ticking
       the chip still removes it, exactly as before. */
    var printFee = print ? (print.getAttribute('data-hup-price') || '0') : '0';
    var okBtn = null, okWrap = null;
    function printPending() { return !!(print && print.hasAttribute('data-hup-pending')); }
    function setPending(on) {
      if (!print) return;
      if (on) {
        print.setAttribute('data-hup-pending', '1');
        print.setAttribute('data-hup-price', '0');
      } else {
        print.removeAttribute('data-hup-pending');
        print.setAttribute('data-hup-price', printFee);
      }
    }
    function okLabel() {
      var fee = parseFloat(printFee) || 0;
      return fee > 0 ? 'הוסיפו · ₪' + fee : 'הוסיפו · במתנה';
    }
    function syncOk() {
      if (!okBtn) return;
      var done = !!(print && print.checked && !printPending());
      okBtn.textContent = done ? '✓ ההדפסה נוספה' : okLabel();
      okBtn.classList.toggle('is-done', done);
      okBtn.setAttribute('aria-pressed', String(done));
    }
    if (print && fields) {
      okWrap = document.createElement('div');
      okWrap.className = 'hup__okwrap';
      okBtn = document.createElement('button');
      okBtn.type = 'button';                    // never submits the form
      okBtn.className = 'hup__ok';
      okBtn.setAttribute('data-hup-ok', '');
      okWrap.appendChild(okBtn);
      var warnEl = fields.querySelector('.hup__warn');
      fields.insertBefore(okWrap, warnEl || null);
      okBtn.addEventListener('click', function () {
        if (!printPending()) return;
        cleanName();
        var okName = !!(nameEl && /[A-Z]/.test(nameEl.value));
        var n = numEl ? parseInt(numEl.value, 10) : NaN;
        var okNum = n >= 1 && n <= 99;
        nameMsg(!okName ? 'נא להקליד שם באותיות באנגלית' : '');
        numMsg(!okNum ? 'מספר בין 1 ל־99' : '');
        if (!okName) { nameEl.focus(); return; }
        if (!okNum) { numEl.focus(); return; }
        setPending(false);
        // Same event every other script already listens to: totals, the
        // drawer's button and the set extras all re-read on it.
        print.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
    var wasChecked = !!(print && print.checked);

    // A hidden required field blocks submission with no visible error, so the
    // flag follows the checkbox rather than sitting in the markup.
    // 28/10/26: required only once the print was ADDED. An open, untouched
    // print never blocks the purchase; an open one with a name typed but never
    // added asks the shopper to press "הוסיפו" (custom validity) rather than
    // silently dropping the name.
    function syncPrint() {
      if (!print || !fields) return;
      if (print.checked && !wasChecked) setPending(true);    // just opened
      if (!print.checked) setPending(false);
      wasChecked = print.checked;
      var added = print.checked && !printPending();
      fields.hidden = !print.checked;
      if (nameEl) nameEl.required = added;
      if (numEl) numEl.required = added;
      if (!print.checked) {
        if (nameEl) nameEl.value = '';
        if (numEl) numEl.value = '';
        nameMsg('');
        numMsg('');
      }
      syncValidity();
      syncOk();
    }
    function syncValidity() {
      if (!nameEl) return;
      var typed = (nameEl.value || '') + (numEl ? numEl.value : '');
      nameEl.setCustomValidity(print && print.checked && printPending() && typed
        ? 'לחצו על "' + okLabel() + '" כדי להוסיף את ההדפסה, או סגרו אותה'
        : '');
    }

    // Character classes, not shorthand escapes: a double-escaped /\\D/ once
    // matched a literal backslash, so '3x2' sanitised to '3x' and would have
    // been printed on a shirt.
    /* 28/10/26 (owner): an inline line the moment an illegal character is
       typed, a live x/12 counter, and a 1–99 line for the number. The hint
       under each field keeps its text; the message is its own line. */
    function msgEl(input) {
      if (!input) return null;
      var m = document.createElement('span');
      m.className = 'hup__msg';
      m.setAttribute('role', 'alert');
      m.hidden = true;
      input.parentNode.appendChild(m);
      return m;
    }
    var nameMsgEl = msgEl(nameEl), numMsgEl = msgEl(numEl);
    function nameMsg(t) { if (nameMsgEl) { nameMsgEl.textContent = t; nameMsgEl.hidden = !t; } }
    function numMsg(t) { if (numMsgEl) { numMsgEl.textContent = t; numMsgEl.hidden = !t; } }
    var nameHint = nameEl ? nameEl.parentNode.querySelector('.hup__hint') : null;
    var counter = null;
    if (nameHint) {
      counter = document.createElement('span');
      counter.className = 'hup__count';
      counter.setAttribute('aria-live', 'polite');
      nameHint.parentNode.insertBefore(counter, nameHint.nextSibling);
    }
    function syncCount() {
      if (counter && nameEl) counter.textContent = (nameEl.value || '').length + '/12';
    }
    function cleanName() {
      var raw = nameEl.value;
      var clean = raw.toUpperCase().replace(/[^A-Z ]/g, '').replace(/ {2,}/g, ' ').replace(/^ /, '');
      if (clean !== raw) nameEl.value = clean;
      // Tell the shopper why the letters vanished instead of silently eating them.
      if (/[^A-Za-z ]/.test(raw)) nameMsg('השם מודפס באותיות באנגלית');
      else if (clean) nameMsg('');
      syncCount();
    }
    if (nameEl) {
      nameEl.addEventListener('input', function () { cleanName(); syncValidity(); syncPipe(); });
      nameEl.addEventListener('compositionend', function () { cleanName(); syncValidity(); syncPipe(); });
      nameEl.addEventListener('blur', function () { cleanName(); this.value = this.value.trim(); syncCount(); syncPipe(); });
      syncCount();
    }
    if (numEl) {
      numEl.addEventListener('input', function () {
        var raw = this.value;
        this.value = raw.replace(/[^0-9]/g, '').slice(0, 2);
        if (/[^0-9]/.test(raw) || this.value === '0' || this.value === '00') numMsg('מספר בין 1 ל־99');
        else if (this.value) numMsg('');
        syncValidity();
        syncPipe();
      });
      numEl.addEventListener('blur', function () {
        if (this.value === '0' || this.value === '00') { this.value = ''; numMsg('מספר בין 1 ל־99'); }
        syncValidity();
        syncPipe();
      });
    }

    function render() {
      syncPrint();
      var total = 0;
      var checked = root.querySelectorAll('.hup__in:checked');
      for (var i = 0; i < checked.length; i++) {
        var el = checked[i];
        // The no-op choices are checked too; only a real value costs money.
        var val = el.hasAttribute('data-hup-print') ? '1' : el.value;
        if (!val) continue;
        total += parseFloat(el.getAttribute('data-hup-price')) || 0;
      }
      if (sum) sum.hidden = total === 0;
      if (total && sumText) sumText.textContent = 'תוספות לפריט: ' + total + ' ₪';

      if (fit) {
        var pro = root.querySelector('[data-hup-pro="1"]');
        fit.hidden = !(pro && pro.checked);
      }
      syncPipe();
    }

    root.addEventListener('change', render);
    // Last word before the line leaves: whatever the keyboard did, the hidden
    // fields carry the sanitised name. Listens only; never blocks the submit.
    if (form) form.addEventListener('submit', syncPipe, true);
    render();
  }

  function scan() {
    var list = document.querySelectorAll('[data-hup]');
    for (var i = 0; i < list.length; i++) initBlock(list[i]);
  }

  scan();

  // Quick shop injects its markup; section rendering replaces it. Both arrive
  // after this script has run, so watch for them instead of assuming one pass.
  if (window.MutationObserver) {
    var pending = false;
    new MutationObserver(function (muts) {
      if (pending) return;
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var el = added[j];
          if (el.nodeType !== 1) continue;
          if (el.hasAttribute('data-hup') || el.querySelector('[data-hup]')) {
            pending = true;
            setTimeout(function () { pending = false; scan(); }, 0);
            return;
          }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  document.addEventListener('shopify:section:load', scan);
})();